export const UPDATE_TASK = '@TASKS/UPDATE_TASK';
export const TOGGLE_STAR = '@TASKS/TOGGLE_STAR';

export const actionCreators = {
    updateTask: (taskId) =>  ({ type: UPDATE_TASK, payload: taskId }),
    toggleStar: (taskId) =>  ({ type: TOGGLE_STAR, payload: taskId })
}
